import { render, staticRenderFns } from "./TeachingVideo.vue?vue&type=template&id=1b33c0f7&scoped=true"
import script from "./TeachingVideo.vue?vue&type=script&lang=js"
export * from "./TeachingVideo.vue?vue&type=script&lang=js"
import style0 from "./TeachingVideo.vue?vue&type=style&index=0&id=1b33c0f7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b33c0f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b33c0f7')) {
      api.createRecord('1b33c0f7', component.options)
    } else {
      api.reload('1b33c0f7', component.options)
    }
    module.hot.accept("./TeachingVideo.vue?vue&type=template&id=1b33c0f7&scoped=true", function () {
      api.rerender('1b33c0f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/details/TeachingVideo.vue"
export default component.exports